import { IRouterLayouts } from "./types";
import constants from "./constants";

import HomePage from "pages-redirects/HomePage/HomePage";

import EnvironmentsContainer from "components/Environments/EnvironmentsContainer";
import CustomersContainer from "components/Customers/CustomersContainer";
import TenantsContainer from "components/Environments/Tenants/TenantsContainer";
import Scheduler from "components/Environments/Tenants/LeftMenu/Scheduler/Scheduler";
import DopeSubscriptionsContainer from "components/Environments/Tenants/LeftMenu/Subscriptions/SubscriptionsContainer";
import RegionalSettings from "components/Environments/Tenants/LeftMenu/RegionalSettings/RegionalSettings";
import DataImport from "components/Environments/Tenants/LeftMenu/DataImport/DataImport";
import GeneralConfigurationsContainer from "components/Environments/Tenants/LeftMenu/GeneralConfigurations/GeneralConfigurationsContainer";
import CustomerDetailsContainer from "components/Customers/CustomerDetails/CustomerDetailsContainer";
import SignalREnrollTenantContainer from "components/Environments/Tenants/EnrollTenant/SignalREnrollTenant/SignalREnrollTenantContainer";
import GuestTenantsConfigContainer from "components/Environments/Tenants/LeftMenu/GuestTenants/GuestTenantsConfigContainer";
import GuestTenantsEnrollContainer from "components/Environments/Tenants/EnrollTenant/StepFrame/GuestTenants/GuestTenantsEnroll/GuestTenantsEnrollContainer";
import ConfigurationLayoutContainer from "layouts/ConfigurationLayout/ConfigurationLayoutContainer";
import DeletedTenantMessageContainer from "components/Environments/Tenants/DeleteTenant/DeletedTenantMessage/DeletedTenantMessageContainer";
import PartnersContainer from "components/Partners/PartnersContainer";
import PartnerDetailsContainer from "components/Partners/PartnerDetails/PartnerDetailsContainer";
import DeliverablesLayout from "layouts/DeliverablesLayout/DeliverablesLayout";
import ErpPackages from "components/Deliverables/ErpPackages/ErpPackages";
import EmailTemplates from "components/Deliverables/EmailTemplates/EmailTemplates";
import FeatureConfigurationsContainer from "components/Environments/Tenants/LeftMenu/FeatureConfigurations/FeatureConfigurationsContainer";
import VersionHistoryContainer from "components/Environments/Tenants/LeftMenu/VersionHistory/VersionHistoryContainer";
import DataRefreshHistoryContainer from "components/Environments/Tenants/LeftMenu/DataRefreshHistory/DataRefreshHistoryContainer";
import MaintenanceModeContainer from "components/Environments/Tenants/LeftMenu/MaintenanceMode/MaintenanceModeContainer";
import Mailboxes from "components/Environments/Tenants/LeftMenu/Mailboxes/Mailboxes";
import ErpConfigurationsContainer from "components/Environments/Tenants/LeftMenu/ErpConfigurations/ErpConfigurationsContainer";
import ActivityLogContainer from "components/Environments/Tenants/LeftMenu/ActivityLog/ActivityLogContainer";
import StorageAccounts from "components/Environments/StorageAccounts/StorageAccounts";
import DooapCustomFields from "components/Environments/Tenants/LeftMenu/CustomFields/Dooap/CustomFields";
import ErpCustomFields from "components/Environments/Tenants/LeftMenu/CustomFields/Erp/CustomFields";
import Studio from "components/Environments/Tenants/LeftMenu/Studio/Studio";

const routes: IRouterLayouts = {
    mainLayout: [
        {
            name: "Main Page",
            path: constants.routePath.root,
            component: HomePage,
        },
        {
            name: "Customers Page",
            path: constants.routePath.customers,
            component: CustomersContainer,
        },
        {
            name: "Environments Page",
            path: constants.routePath.environments,
            component: EnvironmentsContainer,
        },
        {
            name: "Storage Accounts Page",
            path: constants.routePath.storageAccounts,
            component: StorageAccounts,
        },
        {
            name: "Partners Page",
            path: constants.routePath.partners,
            component: PartnersContainer,
        },
        {
            name: "Partner Details",
            path: constants.routePath.partnerDetails,
            component: PartnerDetailsContainer,
        },
        {
            name: "Tenants Page",
            path: constants.routePath.tenants,
            component: TenantsContainer,
        },
        {
            name: "Tenant Configs Page",
            path: constants.tenantConfigsRoutes.tenantConfigs,
            component: ConfigurationLayoutContainer,
        },
        {
            name: "Tenant Customer Details",
            path: constants.routePath.customerDetails,
            component: CustomerDetailsContainer,
        },
        {
            name: "Enroll Tenant Page",
            path: constants.routePath.enrollTenant,
            component: SignalREnrollTenantContainer,
        },
        {
            name: "Enroll New Tenant Page",
            path: constants.routePath.enrollNewTenant,
            component: SignalREnrollTenantContainer,
        },
        {
            name: "Guest tenants enroll",
            path: constants.routePath.guestTenantsEnroll,
            component: GuestTenantsEnrollContainer,
        },
        {
            name: "Deleted tenant",
            path: constants.routePath.deletedTenant,
            component: DeletedTenantMessageContainer,
        },
        {
            name: "Deliverables",
            path: constants.deliverablesRoutes.deliverables,
            component: DeliverablesLayout,
        },
    ],
    deliverablesLayout: [
        {
            name: "Deliverables - ERP Packages",
            path: constants.deliverablesRoutes.packages,
            component: ErpPackages,
        },
        {
            name: "Deliverables - Email Templates",
            path: constants.deliverablesRoutes.templates,
            component: EmailTemplates,
        },
    ],
    configurationLayout: [
        {
            name: "Tenant Configs Page - General Configurations",
            path: constants.tenantConfigsRoutes.generalConfig,
            component: GeneralConfigurationsContainer,
        },
        {
            name: "Tenant Configs Page - Feature Configurations",
            path: constants.tenantConfigsRoutes.featureConfig,
            component: FeatureConfigurationsContainer,
        },
        {
            name: "Tenant Configs Page - ERP Configurations",
            path: constants.tenantConfigsRoutes.erpConfig,
            component: ErpConfigurationsContainer,
        },
        {
            name: "Tenant Configs Page - Dooap Custom Fields",
            path: constants.tenantConfigsRoutes.dooapCustomFields,
            component: DooapCustomFields,
        },
        {
            name: "Tenant Configs Page - Erp Custom Fields",
            path: constants.tenantConfigsRoutes.erpCustomFields,
            component: ErpCustomFields,
        },
        {
            name: "Tenant Configs Page - Studio",
            path: constants.tenantConfigsRoutes.studio,
            component: Studio,
        },
        {
            name: "Tenant Configs Page - Scheduler",
            path: constants.tenantConfigsRoutes.scheduler,
            component: Scheduler,
        },
        {
            name: "Tenant Configs Page - Culture Settings",
            path: constants.tenantConfigsRoutes.cultureSettings,
            component: RegionalSettings,
        },
        {
            name: "Tenant Configs Page - Data Transfer",
            path: constants.tenantConfigsRoutes.dataImport,
            component: DataImport,
        },
        {
            name: "Tenant Configs Page - Guest Tenants",
            path: constants.tenantConfigsRoutes.guestTenants,
            component: GuestTenantsConfigContainer,
        },
        {
            name: "Tenant Configs Page - DOPE Subscriptions",
            path: constants.tenantConfigsRoutes.dopeSubscriptions,
            component: DopeSubscriptionsContainer,
        },
        {
            name: "Tenant Configs Page - Version History",
            path: constants.tenantConfigsRoutes.versionHistory,
            component: VersionHistoryContainer,
        },
        {
            name: "Tenant Configs Page - Data Refresh History",
            path: constants.tenantConfigsRoutes.dataRefreshHistory,
            component: DataRefreshHistoryContainer,
        },
        {
            name: "Tenant Configs Page - Maintenance Mode",
            path: constants.tenantConfigsRoutes.maintenanceMode,
            component: MaintenanceModeContainer,
        },
        {
            name: "Tenant Configs Page - Mailbox Management",
            path: constants.tenantConfigsRoutes.captureMailboxes,
            component: Mailboxes,
        },
        {
            name: "Tenant Configs Page - Activity Logs",
            path: constants.tenantConfigsRoutes.activityLog,
            component: ActivityLogContainer,
        },
    ],
};

export default routes;
